import Phaser from 'phaser';

export class Enemy extends Phaser.Physics.Arcade.Sprite {
  private hp = 15;
  private patrolMin: number;
  private patrolMax: number;
  private dir: 1 | -1 = 1;
  private hurtTimer = 0;
  private dying = false;

  constructor(scene: Phaser.Scene, x: number, y: number, patrolMin: number, patrolMax: number) {
    super(scene, x, y, 'enemy');
    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.patrolMin = patrolMin;
    this.patrolMax = patrolMax;

    // Спрайт жука 67×58 (на 20% меньше прежнего 84×72). Body совпадает с
    // display — иначе враг тонет в полу.
    this.setDisplaySize(67, 58);

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setMaxVelocity(400, 800);
    body.setDragX(0);

    // Idle wobble — лёгкое покачивание в покое (3°), создаёт «жизнь»
    scene.tweens.add({
      targets: this,
      angle: 3,
      duration: 500,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.inOut',
    });
  }

  override preUpdate(time: number, delta: number) {
    super.preUpdate(time, delta);

    if (this.dying) return;

    this.hurtTimer = Math.max(0, this.hurtTimer - delta);
    const body = this.body as Phaser.Physics.Arcade.Body;

    // Пока в knockback — не управляем горизонтальной скоростью
    if (this.hurtTimer === 0) {
      if (this.x <= this.patrolMin) this.dir = 1;
      if (this.x >= this.patrolMax) this.dir = -1;
      body.setVelocityX(50 * this.dir);
      this.setFlipX(this.dir === -1);
    }
  }

  takeDamage(amount: number, knockbackX: number) {
    if (this.dying) return;
    this.hp -= amount;
    this.hurtTimer = 220;

    // Вспышка белым
    this.setTintFill(0xffffff);
    this.scene.time.delayedCall(80, () => {
      if (this.active && !this.dying) this.clearTint();
    });

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocityX(knockbackX);
    body.setVelocityY(-200);

    if (this.hp <= 0) this.die();
  }

  private die() {
    this.dying = true;
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setEnable(false);

    this.scene.tweens.add({
      targets: this,
      alpha: 0,
      scaleX: 0.5,
      scaleY: 0.5,
      duration: 280,
      onComplete: () => this.destroy(),
    });
  }

  isAlive() {
    return !this.dying && this.active;
  }
}
